import { render, staticRenderFns } from "./WebsiteCmsShell.vue?vue&type=template&id=f08a7aa0&scoped=true"
import script from "./WebsiteCmsShell.vue?vue&type=script&lang=js"
export * from "./WebsiteCmsShell.vue?vue&type=script&lang=js"
import style0 from "./WebsiteCmsShell.vue?vue&type=style&index=0&id=f08a7aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08a7aa0",
  null
  
)

export default component.exports